import { Controller } from "@hotwired/stimulus"
import { requestConfirm, openDeletionProgressModal } from "../util"

export default class extends Controller {
  static values = { universityName: String, universityId: Number }

  async confirm(event) {
    event.preventDefault()

    const confirmed = await requestConfirm({ modal: "delete-university", test: this.universityNameValue })
    if (!confirmed) return

    openDeletionProgressModal(this.universityIdValue)
    this.element.requestSubmit()
  }
}
